<template>
  <v-row>
    <v-col cols="6" sm="6" md="6">
      <v-file-input
        show-size
        counter
        v-model="fileUpload"
        accept=".csv"
        label="Seleccione el archivo a migrar:"
        clearable
      ></v-file-input>
    </v-col>
    <!--Empresa Administradora del servicio-->
    <v-col cols="4" sm="4" md="4">
      <v-autocomplete
        v-model="Empresa"
        :items="ArrayaEmpresaResponsable"
        :item-title="
          (ArrayaEmpresaResponsable) =>
            ArrayaEmpresaResponsable.DocumentID +
            '-' +
            ArrayaEmpresaResponsable.Nombre
        "
        item-value="DocumentID"
        color="primary"
        label="Empresa que administra el servicio:"
        dense
        clearable
      >
      </v-autocomplete>
    </v-col>
    <v-col cols="2" sm="2" md="2">
      <v-btn
        block
        @click="convertToBase64()"
        text
        dark
        size="x-large"
        color="green"
      >
        <template v-slot:prepend>
          <v-icon>mdi-content-save</v-icon>
        </template>
        Guardar</v-btn
      >
    </v-col>
  </v-row>
  <div class="d-flex align-center flex-column">
    <!-- Linea de progreso -->
    <v-dialog v-model="progreso" persistent width="auto">
      <v-card color="red-darken-4">
        <v-card-text>
          Espera un momento...
          <v-toolbar align="center" color="red-darken-4">
            <v-img
              class="mx-auto"
              :width="5"
              src="/static/iconos/logo2.png"
            ></v-img>
          </v-toolbar>
          <v-progress-linear
            indeterminate
            color="white"
            class="mb-0"
          ></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
export default {
  name: "Migracion-Activos",
  data() {
    return {
      progreso: false,
      fileUpload: [],
      Empresa: null,
      ArrayaEmpresaResponsable: []
    };
  },
  methods: {
    ///////////////////////////////////////////////// Métodos de consulta ///////////////////////////////////////////
    // Envia Archivo Base 64
    convertToBase64(event) {
      const file = this.fileUpload[0]; // Obtener el archivo seleccionado
       if (!file || !this.Empresa) {
        this.$swal({
          icon: "warning",
          title: "Campos Incompletos.",
          html: " Hay campos que se encuentran incompletos.",
        });
        return;
      }

      const reader = new FileReader();
      reader.readAsDataURL(file); // Leer el archivo como Base64

      reader.onload = () => {
        var base64 = reader.result; // Guardar la cadena Base64
        this.getPostArvhivoAEP(base64); // Enviar la cadena Base64
      };

      reader.onerror = (error) => {
        console.error("Error al convertir a Base64:", error);
      };
    },
    // Envia Archivo Garantías
    async getPostArvhivoAEP(base64) {
      var userperfil = this.$store.getters.userperfil;
      this.progreso = true;
      var data = {
        ArchivoBase64: base64,
        Empresa: this.Empresa,
        User: userperfil.userInfo.Usuario_ID,
      };

      this.axios
        .post("/ActivosO/MigracionActivos/CR0", data)
        .then((response) => {
          this.fileUpload = [];
          this.Empresa = null;
          this.$swal({
            icon: "success",
            title: "Relación Guardada",
            html: "La información se ha guardado correctamente.",
          });
        })
        .catch((error) => {
          const registro = error.response.data;
          const mensajeerror =
            registro.Mensaje || registro.ExceptionMessage || registro;
          switch (error.response.status) {
            case 404:
              this.$swal({
                icon: "warning",
                title: "Consulta inexistente.",
                html: mensajeerror,
              });
              break;
            default:
              this.$swal({
                icon: "error",
                title: "Error al consultar",
                html:
                  " [500] El servidor ha encontrado la siguiente condicion inesperada: <br><small><code>" +
                  mensajeerror +
                  "</code></small>",
              });
              break;
          }
        })
        .finally(() => {
          this.progreso = false;
        });
    },

    // Consulta Empresa Responsable
    async getEmpresaResponsable() {
      this.ArrayaEmpresaResponsable = [];
      this.axios
        .get("/Personas/Cliente/CD3/9")
        .then((response) => {
          this.ArrayaEmpresaResponsable = response.data;
        })
        .catch((e) => console.log(e));
    },
  },
  mounted() {
    this.getEmpresaResponsable();
  },
};
</script>
